<template>
  <div class="bg-[var(--background-color)]">
    <LayoutHeader />

    <main class="mx-auto my-0 flex w-full max-w-[var(--max-content-width)] justify-center">
      <slot />
    </main>

    <LayoutFooter />
  </div>
</template>

<script lang="ts">
import LayoutFooter from "~/components/LayoutFooter/LayoutFooter.vue";
import LayoutHeader from "~/components/LayoutHeader/LayoutHeader.vue";

export default {
  name: "DefaultLayout",

  components: {
    LayoutHeader,
    LayoutFooter,
  },
};
</script>
